// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes oR86t{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}@keyframes oR86t{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}._1LYJU,.ba1EZ,._2Jqc_{margin-top:4rem}._3N7KC{margin-top:2.4rem}._1LYJU{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:start;align-items:flex-start;-webkit-column-gap:2.4rem;-moz-column-gap:2.4rem;column-gap:2.4rem}._1LYJU>button{margin:0}._32SGg{display:-ms-flexbox;display:flex;-ms-flex-align:baseline;align-items:baseline;-ms-flex-pack:justify;justify-content:space-between}._32SGg :only-child{margin-left:auto}", ""]);
// Exports
exports.locals = {
	"actions": "_1LYJU",
	"application": "ba1EZ",
	"google_drive": "_2Jqc_",
	"disclaimer": "_3N7KC",
	"errorHeader": "_32SGg",
	"fading": "oR86t"
};
module.exports = exports;
